<section #carouselListDiv class="carousel-container product-list">
    <div class="listing-container">
        @if (collectionListData().collections; as collections) {
        @if (collections && collections.length > 1) {
        <ul class="collection-label-appearance">
            @for (collection of collections; track collection.id; let i = $index) {
            <li (click)="changeSelectedIndex(i)" [class.disabled]="loader()">
                <span [class.group-item-active]="selectedIndex() === i" class="collection-label-item">{{
                collection?.name
              }}</span>
            </li>
            }
        </ul>
        }
        }

        <!-- empty state -->
        @if (!loader() && !collectionListData()[selectedIndex()]?.length) {
        <div class="empty-sate-wrapper">
            <h1>No Products Available</h1>
        </div>
        }

        <owl-carousel-o #multipleCollectionCarouselList [options]="customOptions()" [ngClass]="{
        'countdown-carousel': countDownTemplate() && countDownPresentSignal(),
      }">
            @for (product of collectionListData()[selectedIndex()]; track product.id; let i = $index) {
            <ng-template carouselSlide>
                <div class="item-list inner-list">
                    <webstore-dynamic-home-product-card [showCountdown]="countDownTemplate() && !!product?.deal" [showCashpoint]="showCashpoint()" [showPercentageDiscount]="showPercentageDiscount()" [showAddToCart]="showAddToCart()" [baseHtml]="baseHtml()" [productInput]="product" (addToCartClicked$)="onAddToCartClicked($event)" (productClicked$)="onProductClicked(product.url_path)">
                    </webstore-dynamic-home-product-card>
                </div>
            </ng-template>
            }
        </owl-carousel-o>

        @if (!loader() && collectionListData()[selectedIndex()]?.length) {
        <div [innerHTML]="carouselListNavigationSection() | safehtml"></div>
        }

        @if (loader()) {
        <webstore-card-loader></webstore-card-loader>
        }
    </div>
</section>